import { DropdownTriggerButton, FilterDropdown } from '../components/dropdown';
import type { TagOption } from '../components/tags';
import { createFilter } from '../create-filter';
import { type FilterProps } from '../types';
import { arrayFilterMethods, getSingleValueLabel } from '../utils';
import { TagsControl } from './tags-control';

export type DropdownTagsControlProps<T = string> = FilterProps<
  T[],
  {
    label: string;
    options: TagOption<T>[];
    triggerWithBackground?: boolean;
  }
>;

export const DropdownTagsControl = createFilter(
  function UnboundDropdownTagsControl({
    filter,
    label,
    options,
    triggerWithBackground
  }: DropdownTagsControlProps) {
    const { resetSelectedValues, isApplied, isSelected, appliedSize } =
      arrayFilterMethods(filter);

    return (
      <FilterDropdown
        trigger={
          <DropdownTriggerButton
            selected={isApplied}
            badge={appliedSize > 1 ? appliedSize : undefined}
            withBackground={triggerWithBackground}
          >
            {getSingleValueLabel(filter.appliedValue, options, label)}
          </DropdownTriggerButton>
        }
        displayClearButton={isSelected}
        onClearRequest={resetSelectedValues}
        maxWidth={400}
        maxHeight={320}
      >
        <TagsControl options={options} filter={filter} />
      </FilterDropdown>
    );
  }
);
